export default "__VITE_ASSET__DcMK4d4x__"